export var texts = {
  sendEmailText: {
    header: "To be extra safe, let's confirm it's really you ",
    description: 'We will send a one-time code to: ',
    buttonText: 'Send Code',
    footer: 'Wrong email address?',
    footerFAQ: 'Check our FAQs.',
    footerTitle: 'This code will expire in 5 minutes'
  },
  validateCodeText: {
    header: "We've sent a code to your email",
    description: 'Please enter the one-time verification code we’ve sent to:',
    codePlaceholder: 'Enter code here',
    secondDecription: "Didn\u2019t receive an email? ",
    requestCodeLink: 'Request a new code',
    buttonText: 'Confirm',
    footer: "Make sure our email didn't go to your spam folder. You can also ",
    footerSendAgain: 'request a new one',
    footerWrongAddress: 'Wrong email address? ',
    footerCheckFAQ: 'Check our FAQs'
  },
  errorMessages: {
    invalid_grant: 'Invalid code. Please try again.',
    expired_token: 'This code expired. Click the link below to get a new one.',
    downstream_server_issue: "It's not you, it’s us. Please try again later.",
    unknown_mfa_error: 'Something went wrong.',
    start_over_link_text: 'please start over.',
    request_new_token: 'Request a new code',
    too_many_requests: "You've tried too many times. For your security, ",
    try_again_text: 'try again',
    later_text: ' in 5 minutes.'
  }
};